import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import '@vds-tokens/typography';
import { ColorTokens } from '@vds-tokens/color';
import { withVDSManager } from '@vds-core/utilities';
import { Fonts } from '../../fonts/index.js';
import Typography from '../Typography/Typography.js';
import SubtitleConfig from './config.js';

const propTypes = {
  /**
   * Primitive used for the component.
   */
  primitive: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span', 'p']),
  /**
   * Viewport the font styling is based on. Desktop and tablet are the same size.
   */
  viewport: PropTypes.oneOf(['desktop', 'tablet', 'mobile']),
  /**
   * Content that will be passed to the component.
   */
  children: PropTypes.node,
  /**
   *  If provided, used as string that labels the element for accessibility.
   */
  ariaLabel: PropTypes.string,
  /**
   * Color of the text.
   */
  color: PropTypes.oneOf(['#000000', '#FFFFFF', '#ffffff', '#EE0000', '#ee0000', '#F6F6F6', '#f6f6f6', '#D8DADA', '#d8dada', '#A7A7A7', '#a7a7a7', '#6F7171', '#6f7171', '#333333', '#1B1D1F', '#1b1d1f', '#FBE4D7', '#fbe4d7', '#ED7000', '#ed7000', '#C44904', '#c44904', '#4A1C02', '#4a1c02', '#FFF4E0', '#fff4e0', '#FFBC3D', '#ffbc3d', '#523C14', '#523c14', '#D6EEFB', '#d6eefb', '#0096E4', '#0096e4', '#0077B4', '#0077b4', '#002B42', '#002b42', '#D6F2E0', '#d6f2e0', '#00AC3E', '#00ac3e', '#008330', '#003614']),
  /**
   * The tabIndex of the text.
   */
  tabIndex: PropTypes.number,
  /**
   * Assigns an Id to the component
   */
  id: PropTypes.string,
  /**
   * Adds an aria-labelledby attribute to the component
   */
  ariaLabelledBy: PropTypes.string,
  /**
   * Assigns an testid to the component
   */
  'data-testid': PropTypes.string
};
const defaultProps = {
  primitive: 'p',
  viewport: 'desktop',
  children: null,
  color: ColorTokens.palette.black.value
};
const StyledSubtitle = styled(Typography).withConfig({
  displayName: "StyledSubtitle",
  componentId: "VDS__sc-ufzqxp-0"
})`
  &:active,
  &:focus,
  &:hover {
    outline: none;
  }
`;
/**
 * @ignore
 */
const Subtitle = props => {
  const {
    children,
    primitive,
    viewport,
    color,
    tabIndex,
    ariaLabel,
    id,
    ariaLabelledBy,
    'data-testid': testId
  } = props;
  const viewportToUse = viewport === 'mobile' ? 'mobile' : 'desktop';
  const fontConfig = SubtitleConfig['VDS'][viewportToUse];
  return React.createElement(StyledSubtitle, {
    fontSize: fontConfig.fontSize,
    fontWeight: fontConfig.fontWeight,
    fontFamily: Fonts.VerizonNHGeDS,
    lineheight: fontConfig.lineHeight,
    primitive: primitive,
    color: color,
    tabIndex: tabIndex,
    "aria-hidden": tabIndex < 0,
    "aria-label": ariaLabel,
    id: id,
    "aria-labelledby": ariaLabelledBy,
    "data-testid": testId
  }, children);
};
Subtitle.propTypes = propTypes;
Subtitle.defaultProps = defaultProps;
var Subtitle$1 = withVDSManager(Subtitle);

export { Subtitle$1 as default };
